module.exports = __webpack_public_path__ + "media/images/mypage/btn05-c8b62ab2a7cb79fd8f3d5300711398f2.gif";